/**
 * Sinh mã định danh từ tên người dùng gõ (ADR-UI-0014).
 *
 * Mã kiểu `KE_TOAN_TRUONG` là chuyện của máy — khoá ổn định trong API, token,
 * audit — nên người dùng không phải tự nghĩ hay gõ. Form chỉ hỏi tên, mã đi
 * theo tên cho tới lúc gửi và hiện ra để người dùng biết, không cho sửa.
 *
 * Luật: bỏ dấu tiếng Việt (`đ` → `d`), viết hoa, mọi ký tự ngoài chữ và số
 * thành `_`, gộp `_` liền nhau, bỏ `_` hai đầu, cắt theo `toiDa`. Mã phải mở
 * đầu bằng chữ và dài ít nhất hai ký tự, nên tên mở đầu bằng số (`2026 Kiểm
 * toán`) hay chỉ một chữ thì thêm `tienTo` phía trước.
 *
 * Tên không có chữ hay số nào (chỉ ký hiệu) cho ra chuỗi rỗng: form báo lỗi ở
 * ô tên thay vì bịa một mã.
 */
export function sinhMa(ten: string, { tienTo, toiDa }: { tienTo: string; toiDa: number }): string {
  let ma = ten
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  if (!ma) return '';
  if (!/^[A-Z]/.test(ma) || ma.length < 2) ma = `${tienTo}_${ma}`;
  return ma.slice(0, toiDa).replace(/_+$/, '');
}
